import React from 'react';
import heroFond from '../assets/espaces-culturel/fond.jpg';

const FOOTER_TOKENS = ['const build = () =>', 'npm run ship', 'git push origin', 'export default'];

const FooterHeroBackground = () => (
  <div className="rihen-footer__bg" aria-hidden="true">
    <div
      className="rihen-footer__bg-photo"
      style={{ backgroundImage: `url('${heroFond}')` }}
    />
    <div className="rihen-footer__bg-grid" />
    <div className="rihen-footer__spine" />
    <div className="rihen-footer__tokens">
      {FOOTER_TOKENS.map((token, index) => (
        <span key={token} className="rihen-footer__token" style={{ '--token-i': index }}>
          {token}
        </span>
      ))}
    </div>
  </div>
);

export const FooterNavLink = ({ href, onClick, children, className = '' }) => (
  <a
    href={href}
    className={`rihen-nav-link rihen-footer__nav-link ${className}`.trim()}
    onClick={onClick}
  >
    <span className="rihen-nav-link__text">{children}</span>
    <span className="rihen-nav-link__rule" aria-hidden="true">
      <span className="rihen-nav-link__open">&lt;</span>
      <span className="rihen-nav-link__track">
        <span className="rihen-nav-link__bar" />
      </span>
      <span className="rihen-nav-link__close">&gt;</span>
    </span>
  </a>
);

export default FooterHeroBackground;
